import { useEffect, useRef, useState } from "react";
import api from "../api";
import "./Login.css"; // corregido (L mayúscula)

export default function Login({ setUsuario }) {
  const [nombre, setNombre] = useState("");
  const [password, setPassword] = useState("");
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");
  const [mostrarPwd, setMostrarPwd] = useState(false);
  const [recordar, setRecordar] = useState(false);
  const userRef = useRef(null);

  useEffect(() => {
    const remembered = localStorage.getItem("rememberedUser");
    if (remembered) {
      setNombre(remembered);
      setRecordar(true);
    }
    userRef.current?.focus();
  }, []);

  const handleLogin = async (e) => {
    e?.preventDefault();
    setCargando(true);
    setError("");

    try {
      const { data } = await api.post("/api/login", { nombre, password });

      if (data?.ok) {
        localStorage.setItem("usuario", JSON.stringify(data.user));
        localStorage.setItem("token", data.token);
        if (recordar) localStorage.setItem("rememberedUser", nombre);
        else localStorage.removeItem("rememberedUser");
        setUsuario(data.user);
      } else {
        setError(data?.error || "Credenciales inválidas");
      }
    } catch(err) {
  if (err.response) {
    setError(err.response.data.error || "Credenciales inválidas");
  } else {
    setError("Error de red");
  }
}

  };

  const deshabilitado = cargando || !nombre.trim() || !password;

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Iniciar Sesión</h2>
        <p className="subtitle">Caja POS • La Sushitería</p>

        {error ? (
          <div className="alert" role="alert" aria-live="assertive">
            {error}
          </div>
        ) : null}

        <form onSubmit={handleLogin} noValidate>
          <div className="field has-icon">
            <span className="icon" aria-hidden="true">👤</span>
            <input
              ref={userRef}
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Usuario"
              autoComplete="username"
              required
              aria-invalid={Boolean(error) && !nombre ? "true" : "false"}
            />
          </div>

          <div className="field has-icon has-toggle">
            <span className="icon" aria-hidden="true">🔒</span>
            <input
              type={mostrarPwd ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Contraseña"
              autoComplete="current-password"
              required
              aria-invalid={Boolean(error) && !password ? "true" : "false"}
            />
            <button
              type="button"
              className="toggle-pwd"
              onClick={() => setMostrarPwd((v) => !v)}
              aria-label={mostrarPwd ? "Ocultar contraseña" : "Mostrar contraseña"}
              title={mostrarPwd ? "Ocultar contraseña" : "Mostrar contraseña"}
            >
              {mostrarPwd ? "🙈" : "👁️"}
            </button>
          </div>

          <div className="extras">
            <label className="remember">
              <input
                type="checkbox"
                checked={recordar}
                onChange={(e) => setRecordar(e.target.checked)}
              />{" "}
              Recuérdame
            </label> 

          </div>

          <button type="submit" disabled={deshabilitado}>
            {cargando ? "Entrando..." : "Entrar"}
          </button>

          <p className="footnote">© 2025 La Sushitería</p>
        </form>
      </div>
    </div>
  );
}
